import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MasterMakeService {

  constructor(
    private readonly http: HttpClient
  ) { }

  saveVehicleMake(payload:any): Observable<any>{
    let url = environment.BASE_URL + '/v1/vehicle-make';
    return this.http.post(url, payload);
  }

  saveTyreMake(payload:any): Observable<any>{
    let url = environment.BASE_URL + '/v1/tyre-make';
    return this.http.post(url, payload);
  }

  getMakeDetails(searchTerm?:any){
    let url = environment.BASE_URL + '/v1/vehicle-make';
    return this.http.get(url,{params : searchTerm });
  }

  getTyreMakeDetails(pageNumber?:any,searchTerm?:any){
    let url = environment.BASE_URL + '/v1/tyre-make';
    return this.http.get(url,{ params: {pageNumber,searchTerm:(searchTerm || '')} });
  }

  getTyreMakeDetailsWithNoPagination(searchTerm?:any){
    let url = environment.BASE_URL + '/v1/tyre-make';
    return this.http.get(url,{ params: searchTerm });
  }

  getTyreMakeBySize(pageNumber?:any, searchTerm?:any){
    let url = environment.BASE_URL + '/v1/tyres-model/brands';
    return this.http.get(url,{ params: {pageNumber,searchTerm:(searchTerm || '')} });
  }

  getTyreDetails(pageNumber?:any,searchTerm?:any){
    let url = environment.BASE_URL + '/v1/tyres';
    return this.http.get(url,{ params: pageNumber,...searchTerm });
  }

  updateMakeDetails(payload:any,makeId:any){
    let url = environment.BASE_URL + `/v1/vehicle-make/${makeId}`;
    return this.http.put(url,payload);
  }

  updateTyreMakeDetails(payload:any,makeId:any){
    let url = environment.BASE_URL + `/v1/tyre-make/${makeId}`;
    return this.http.put(url,payload);
  }

  getMetaDataDetails(): Observable<any>{
    let url = environment.BASE_URL + '/v1/metadata';
    return this.http.get(url);
  }

  getActiveMetaDataDetails(): Observable<any> {
    const url = `${environment.BASE_URL}/v1/metadata`;
    const params = new HttpParams().set('status', 'Active');
    return this.http.get(url, { params });
  }

  addMetaDataDetails(payload:any): Observable<any>{
    let url = environment.BASE_URL + '/v1/metadata';
    return this.http.post(url, payload);
  }

  updateMetaDataDetails(payload:any,id:any){
    let url = environment.BASE_URL + `/v1/metadata/${id}`;
    return this.http.put(url,payload);
  }

  metaDataStatus(payload:any,id:any){
    let url = environment.BASE_URL + `/v1/metadata/${id}/status`;
    return this.http.put(url,payload);
  }
}
